import { render, staticRenderFns } from "./serverRecord.vue?vue&type=template&id=3b545cff&scoped=true&"
import script from "./serverRecord.vue?vue&type=script&lang=js&"
export * from "./serverRecord.vue?vue&type=script&lang=js&"
import style0 from "./serverRecord.vue?vue&type=style&index=0&id=3b545cff&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b545cff",
  null
  
)

export default component.exports